// src/components/ProductDetailsCP.js
import React from 'react';
import { FaPrint, FaThermometerHalf, FaMobileAlt } from 'react-icons/fa';
import { MdSpeed, MdTouchApp, MdNetworkCheck } from 'react-icons/md';
import './ProductDetails.css';
import Cp30 from '../resorcesfiles/ideak/cp30.jpg'; // Use your provided image path
import Mainmastet from '../masterpage/Mainmastet';

const ProductDetailsCP = () => {
  return (
    <Mainmastet content={<>
    
    <div className="product-details-container">
      <h1>Powerful RFID and Barcode Printing, Speedy and Highly Secured</h1>
      <div className="product-content">
        <div className="product-details">
          <div className="features">
            <div className="feature-item">
              <MdTouchApp size={32} />
              <p>3.5" LCD Touch Display</p>
            </div>
            <div className="feature-item">
              <MdSpeed size={32} />
              <p>Maximum Print Speed: 8ips (203dpi) / 6ips (300dpi)</p>
            </div>
            <div className="feature-item">
              <MdNetworkCheck size={32} />
              <p>Support Multiple Interfaces</p>
            </div>
            <div className="feature-item">
              <FaPrint size={32} />
              <p>Automatic Printhead Resolution Identification</p>
            </div>
          </div>
        </div>
        <div className="product-image-container">
          <img src={Cp30} alt="Product CP30" className="product-image" />
        </div>
      </div>
      <div className="functions-container">
        <h2>Functions</h2>
        <div className="functions">
          <div className="function-item">
            <FaThermometerHalf size={32} />
            <p>Thermal Transfer / Direct Thermal</p>
          </div>
        </div>
      </div>
    </div>
    
    </>} />
  );
};

export default ProductDetailsCP;
